import {useCurrentProject} from 'common/contexts/react/current-project-context';
import type {CurrentProject} from 'common/report/model-resources/projects';
import {FeatureRollout, FeatureRolloutName, FeatureRollouts} from 'common/report/util/feature-sampling';
import {isPublicMode} from 'common/report/util';

export function getFeatureRollout(project: CurrentProject, rollout: FeatureRolloutName | FeatureRollout) {
  return FeatureRollouts[typeof rollout === `string` ? rollout : rollout.name].isEnabled(project);
}

/**
 * A hook that checks if a feature flag is enabled for the current project.
 *
 * This hook handles features being enabled both with rollouts and by being explicitly set in AppDB.
 * If you need this outside a React component, use getFeatureRollout instead.
 *
 * @param flag - The feature rollout to check.
 */
export function useFeatureRollout(rollout: FeatureRolloutName) {
  const currentProject = useCurrentProject();

  /** guards against public boards not having project access */
  if (isPublicMode()) {
    return false;
  }

  const projectValue = currentProject.get().value;
  if (projectValue) {
    return getFeatureRollout(projectValue, rollout);
  }

  return false;
}
